import { ChatManager } from "@/components/chat";

import { ChatWorkspaceContentRedesignedV2 } from "./ChatWorkspaceContentRedesignedV2";

interface ChatWorkspaceContentProps {
    isChatWorkspaceRedesignV2Enabled: boolean;
}

export function ChatWorkspaceContent({ isChatWorkspaceRedesignV2Enabled }: ChatWorkspaceContentProps) {
    if (isChatWorkspaceRedesignV2Enabled) {
        return <ChatWorkspaceContentRedesignedV2 />;
    }

    return <ChatManager />;
}
